import type { ChangeEvent } from "react";

import { TextInput } from "@narmi/design_system";

export type SearchFilterPanelProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const SearchFilterPanel = ({
  value,
  onChange,
  placeholder,
}: SearchFilterPanelProps) => (
  <TextInput
    startIcon="search"
    placeholder={placeholder}
    value={value}
    onChange={(event: ChangeEvent<HTMLInputElement>) =>
      onChange(event.target.value ?? "")
    }
    showClearButton
  />
);

export default SearchFilterPanel;
